import React from "react";
import { Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ROUTE_NAMES } from "../../Routes/routes";
import { firebaseServices } from "../../services/firebase";
import { storageServices } from "../../services/storage";
import api from "../../api";

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loading: false,
    };

    //     const FB = window.FB;
    // FB.init({
    //     appId            : '281814379634072',
    //     autoLogAppEvents : true,
    //     xfbml            : true,
    //     version          : 'v8.0'
    //   });
  }
  async componentDidMount() {
    if (await firebaseServices.getCurrentUser()) {
      this.props.history.push(ROUTE_NAMES.dashboard);
    }
  }
  handleChange = (event) => {
    try {
      const { name, value } = event.target;
      this.setState({ [name]: value });
    } catch (error) {
      console.log(error);
    }
  };
  handleFacebookLogin = async (event) => {
    this.setState({ loading: true });
    const { history } = this.props;
    firebaseServices
      .loginWithFacebook()
      .then(
        async function (result) {
          var customerData = {
            uid: "",
            email: "",
            providerId: "",
            facebook: {},
          };
          console.log("Fb user:", result);
          //To Firebase
          let userProfile = { ...result?.additionalUserInfo?.profile };
          userProfile.picture = result?.user?.photoURL;
          userProfile["accessToken"] = result?.credential?.accessToken;
          // delete userProfile.granted_scopes;
          result?.additionalUserInfo?.profile &&
            (await firebaseServices.setFbUserIdToDb(userProfile));
          // To Loacl DB
          let uid = result?.user?.uid;
          customerData["uid"] = uid;
          customerData["email"] = result?.user?.email;
          customerData["facebook"]["userProfile"] = userProfile;
          customerData["providerId"] = result?.additionalUserInfo?.providerId;

          await storageServices.setCurrentUser(customerData);

          (await result?.additionalUserInfo?.profile) &&
            this.setFbUserToLocalDb(uid, customerData);
          await this.setState({ loading: false });
          if (!this.state.loading) {
            history.push(ROUTE_NAMES.dashboard);
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          this.setState({ loading: false });
          alert(error.message);
        }.bind(this)
      );
  };
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    const { email, password } = this.state;
    const { history } = this.props;
    try {
      await firebaseServices.loginWithEmail(email, password);
      await this.findUserDb();
      //localStorage.setItem('user', {login_status:true,email:email});

      await this.setState({ loading: false });
      history.push(ROUTE_NAMES.dashboard);
    } catch (error) {
      this.setState({ loading: false });
      alert(error);
    }
  };

  async setFbUserToLocalDb(uid, payload) {
    await api.updateCustomerByUid(uid, payload).then(
      (res) => {
        console.log("Response:", res);
        let data = res?.data?.data;
        console.log("user details", data);
      },
      (error) => {
        console.log("error", error);
      }
    );
  }

  findUserDb = async (event) => {
    const { email } = this.state;

    await api.getCustomerByEmail(email).then(
      (res) => {
        console.log("Response:", res);
        let data = res.data.data;
        localStorage.setItem("user", JSON.stringify(data));
        console.log("user details", data);
      },
      (error) => {
        console.log("error", error);
      }
    );
  };
  render() {
    const { loading } = this.state;
    return (
      <div>
        <div className="d-flex align-items-center auth px-0 bg-gradient-primary">
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                <div className="brand-logo text-center">
                  <img
                    src={"/images/logo.png"}
                    alt="logo"
                  />
                </div>
                <h4>Existing Brand</h4>
                <h6 className="font-weight-light">Sign in to continue.</h6>
                <Form className="pt-3" onSubmit={this.handleSubmit}>
                  <Form.Group className="d-flex search-field">
                    <Form.Control
                      type="email"
                      name="email"
                      onChange={this.handleChange}
                      placeholder="Username"
                      size="lg"
                      className="h-auto"
                    />
                  </Form.Group>
                  <Form.Group className="d-flex search-field">
                    <Form.Control
                      onChange={this.handleChange}
                      name="password"
                      type="password"
                      placeholder="Password"
                      size="lg"
                      className="h-auto"
                    />
                  </Form.Group>
                  <div className="mt-3">
                    <Button
                      className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                      variant="primary"
                      block
                      type="submit"
                    >
                      {loading ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        >
                          {"  "}
                        </span>
                      ) : (
                        "SIGN IN"
                      )}
                    </Button>
                  </div>
                  <div className="my-2 d-flex justify-content-between align-items-center">
                    <div className="form-check">
                      <label className="form-check-label text-muted">
                        <input type="checkbox" className="form-check-input" />
                        <i className="input-helper"></i>
                        Keep me signed in
                      </label>
                    </div>
                    <a
                      href="!#"
                      onClick={(event) => event.preventDefault()}
                      className="auth-link text-black"
                    >
                      Forgot password?
                    </a>
                  </div>
                  <div className="mb-2">
                    <button
                      type="button"
                      className="btn btn-block btn-facebook auth-form-btn"
                      onClick={this.handleFacebookLogin}
                    >
                      <i className="mdi mdi-facebook mr-2"></i>Connect using
                      facebook
                    </button>
                  </div>
                  <div className="text-center mt-4 font-weight-light">
                    New Brand?{" "}
                    <Link to={ROUTE_NAMES.register} className="text-primary">
                      Register here
                    </Link>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
